import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MaterialDlaKlientaService as MaterialDlaKlientaService } from '../../@core/http/material-dla-klienta-service';
import { MaterialDlaKlienta } from '../../shared/models/material-dla-klienta.model';

@Component({
  selector: 'ngx-materialy-dla-klienta',
  templateUrl: './materialy-dla-klienta.component.html',
  styleUrls: ['./materialy-dla-klienta.component.scss'],
})
export class MaterialyDlaKlientaComponent implements OnInit {

  @ViewChild('hdrTpl', { static: true }) hdrTpl: TemplateRef<any>;

  dane: MaterialDlaKlienta[];

  constructor(
    private readonly materialDlaKlientaService: MaterialDlaKlientaService,
    ) { }

  ngOnInit(): void {
    this.materialDlaKlientaService.getMaterialyDlaKlienta().subscribe(response => {
      this.dane = response;
    });
  }

}
